/* ============================================================
   SDÍLENÁ LOGIKA KOMPONENT (společná pro všechny 4 varianty)
   Selector-driven: každá varianta poskládá stejné stavební bloky
   pomocí data-atributů; tento soubor je oživí.
   ============================================================ */
(function () {
  "use strict";
  const P = window.PRODUCT;
  // slevové prahy seřaď vzestupně dle množství — renderLadder i discountFor počítají se seřazením
  if (P && Array.isArray(P.discounts)) P.discounts.sort((a, b) => a.min - b.min);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  // HTML-escaping: názvy barev (option values) i další produktová data jdou do innerHTML
  // a do atributů. `| json` v Liquidu zajistí bezpečný JS literál, NE bezpečné HTML —
  // uvozovka/<,> v názvu barvy by jinak rozbila markup nebo umožnila injektáž atributu.
  const escapeHtml = (s) =>
    String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  // kořen sekce — nese stavové třídy (mobile/tablet/desktop/is-soldout/rm) místo <body>,
  // aby nascopované CSS (.nebe-pdp.mobile …) fungovalo a neznečišťovalo zbytek šablony
  let ROOT;
  const root = () => ROOT || (ROOT = document.querySelector(".nebe-pdp") || document.body);

  // ---- rozměry pod velikostí: JEDINÝ zdroj = přiřazená velikostní tabulka ----
  // Parsujeme tabulku přímo z modalu (.sizeguide-rich), který renderuje obsah přiřazené
  // size-guide stránky (metafield custom.size_guide). Tím je rozměr pod velikostí vždy 1:1
  // s tabulkou a ukáže VŠECHNY parametry (např. tílka: přes prsa + pas) — žádná ručně
  // psaná čísla. Popisky bere z hlavičky tabulky, jednotku z „(v cm)". Když produkt nemá
  // přiřazenou tabulku (parser vrátí null), paintMeasure padá zpět na P.sizeHips (1 hodnota).
  const SIZE_MEASURES = (function () {
    try {
      const table = document.querySelector(".sizeguide-rich table");
      if (!table) return null;
      const ths = table.querySelectorAll("thead th");
      if (ths.length < 2) return null;
      // popisky parametrů = hlavičky kromě 1. sloupce (velikost); jednotku z „(… cm)" odděl
      const params = [];
      for (let i = 1; i < ths.length; i++) {
        let raw = (ths[i].textContent || "").replace(/\s+/g, " ").trim();
        let unit = "";
        const m = raw.match(/\(([^)]*)\)/);
        if (m) {
          unit = m[1].replace(/^v\s+/i, "").trim();
          raw = raw.replace(/\([^)]*\)/, "").trim();
        }
        params.push({ label: raw, unit: unit });
      }
      const map = {};
      table.querySelectorAll("tbody tr").forEach((tr) => {
        const tds = tr.querySelectorAll("td");
        if (tds.length < 2) return;
        const size = (tds[0].textContent || "").trim();
        if (!size) return;
        const arr = [];
        for (let j = 1; j < tds.length; j++) {
          let val = (tds[j].textContent || "")
            .replace(/\s+/g, " ")
            .replace(/\s*až\s*/i, "–")
            .trim();
          if (!val) continue;
          const p = params[j - 1] || { label: "", unit: "" };
          if (p.unit && val.indexOf(p.unit) === -1) val += " " + p.unit;
          arr.push({ label: p.label, value: val });
        }
        if (arr.length) map[size] = arr;
      });
      return Object.keys(map).length ? map : null;
    } catch (e) {
      return null;
    }
  })();

  // ---- parametry z URL (debug lišta) ----
  const params = new URLSearchParams(location.search);
  // device třída (.mobile/.tablet/.desktop) řídí responzivní rozvržení
  // Na živém webu řídí rozvržení reálná šířka okna (ne ?d=). Breakpointy 768 / 1024.
  const dev = params.get("d");
  const deviceFromWidth = () =>
    window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop";
  function applyDev() {
    root().classList.remove("mobile", "tablet", "desktop");
    root().classList.add(dev || deviceFromWidth());
  }
  let _devLast;
  window.addEventListener(
    "resize",
    () => {
      if (dev) return;
      const d = deviceFromWidth();
      if (d !== _devLast) {
        _devLast = d;
        applyDev();
      }
    },
    { passive: true }
  );

  // ---- překlady (i18n) ----
  // texty táhneme z window.NEBE_I18N (locale soubory motivu). Když klíč chybí (např. stará
  // verze locale), spadneme na český fallback, ať se UI nikdy nerozbije.
  const I18N = window.NEBE_I18N || {};
  const I18N_FALLBACK = {
    ship_24h: "expedice do 24 hodin", ship_monday: "expedice hned v pondělí", ship_tomorrow: "expedice již zítra",
    sold_thousands: "Tisíce prodaných v poslední době", sold_hundreds: "Stovky prodaných v poslední době",
    stock_size_out: "Tahle velikost teď není skladem", stock_last_n: "⚡ Poslední %{n} ks skladem",
    stock_few: "Skladem posledních pár kusů · %{ship}", stock_in: "Skladem · %{ship}",
    stock_color_out: "Tahle barva je teď vyprodaná", soldout_btn: "Vyprodáno",
    size_err: "Vyber prosím velikost 🤍", qty_nag: "Skladem máme posledních %{n} %{unit} 🤍",
    unit_one: "kus", unit_few: "kusy", unit_many: "kusů",
    bundle_popular: "Nejoblíbenější", bundle_best: "Nejlepší cena", bundle_save: "ušetříš %{amount}", bundle_more: "a více", price_yearlow: "Nejnižší cena roku", size_measure_label: "Boky",
    bundle_combo_html: "💡 Lepší cenu získáš i namícháním <b>různých barev a velikostí</b> téhož modelu.",
    per_piece: " / ks", reviews_count: "%{n} recenzí",
    aria_prev_photo: "Předchozí foto", aria_next_photo: "Další foto",
    aria_gallery: "Fotky – %{name}", aria_slide: "%{i} z %{n}",
    lightbox_close: "Zavřít", lightbox_prev: "Předchozí", lightbox_next: "Další",
    topbar_rating_aria: "Hodnocení %{rating} z 5, %{count} recenzí", add_error: "Nepovedlo se přidat do košíku",
    qty_less: "Méně", qty_more: "Více",
    // FIT-HINT (QW-A0): jemné vodítko k velikosti. Tón „nebe" = pohoda/opora, NIKDY „škrtí/pozor".
    // Texty lze přepsat přes locale (window.NEBE_I18N) bez zásahu do kódu — až oprava tabulky (QW-A1)
    // sníží posun „o velikost větší", stačí zde zeslabit/odebrat „vol větší".
    fit_rs_line: "Muse má jemnou, přilnavou oporu — při váhání mezi velikostmi vol&nbsp;větší. 🤍",
    fit_rs_small_sel: "Váháš mezi velikostmi? V téhle řadě bývá pohodlnější o číslo&nbsp;větší.",
    fit_tts_line: "Padne přesně podle tabulky velikostí.",
    fit_guide_toggle: "Poradíme s velikostí",
    fit_guide_b1: "Vyber velikost, kterou běžně nosíš v tričku nebo podprsence.",
    fit_guide_b2: "Mezi dvěma? U Muse vol větší — měkká bambusová opora se přizpůsobí.",
    fit_guide_b3_link: "Otevřít přesnou tabulku rozměrů →",
    fit_gift_line: "Kupuješ jako dárek? Velikost pak v klidu a zdarma vyměníme. 🎁",
  };
  // T("klíč", {n:3}) → přeloží a doplní placeholdery %{...}
  function T(key, vars) {
    let s = I18N[key];
    // klíč chybí v locale motivu (Shopify vrací „translation missing…") → český fallback
    if (s == null || /translation missing/i.test(s)) s = I18N_FALLBACK[key];
    if (s == null) return key;
    if (vars) for (const p in vars) s = s.split("%{" + p + "}").join(vars[p]);
    return s;
  }
  // skloňování „kus": čeština/slovenština 1 / 2–4 / ostatní; angličtina 1 / ostatní
  const isEn = /^en/i.test(I18N.lang || "cs");
  function unitWord(n) {
    const one = T("unit_one"), few = T("unit_few"), many = T("unit_many");
    if (isEn) return n === 1 ? one : many;
    return n === 1 ? one : n >= 2 && n <= 4 ? few : many;
  }

  // ---- stav ----
  const SUBP = P.subscription || null; // konfigurace předplatného (jen varianta D-4s)
  let subEnabled = false; // true, když je na stránce blok [data-purchase]
  const state = {
    color: 0,
    size: null,
    qty: 1,
    mode: "onetime", // "onetime" | "sub"
    freq: SUBP ? SUBP.frequencies[0].weeks : null,
  };
  const subActive = () => subEnabled && state.mode === "sub";
  const listeners = [];
  const onChange = (fn) => listeners.push(fn);
  const emit = () => listeners.forEach((fn) => fn(state));

  // ---- košík (pub/sub pro počítadlo v hlavičce) ----
  let cartCount = 0;
  const cartListeners = [];
  const onCart = (fn) => cartListeners.push(fn);
  const addCart = (n) => {
    cartCount += n;
    cartListeners.forEach((fn) => fn(cartCount));
  };

  // ---- formátování ceny (vstup v setinách měny: haléře/centy) ----
  // Měna i počet desetin se řídí aktuálním marketem, ne natvrdo "Kč".
  // Počet desetin čteme z Shopify `money` vzoru (P.moneySample pro 123,45):
  // CZK je obvykle bez haléřů → 0 desetin a zaokrouhlení (jako košík),
  // EUR/USD s haléři → 2 desetiny a žádné zaokrouhlení (PDP == košík → 37,95 €).
  const fmt = (function () {
    const sample = String(P.moneySample || "");
    const frac = sample.replace(/[^\d.,]/g, "").split(/[.,]/);
    const decimals = frac.length > 1 ? frac[frac.length - 1].length : 0;
    let nf = null;
    try {
      nf = new Intl.NumberFormat(P.locale || "cs-CZ", {
        style: "currency",
        currency: P.currencyCode || "CZK",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    } catch (e) {
      nf = null;
    }
    return function (h) {
      const major = decimals === 0 ? Math.round(h / 100) : h / 100;
      if (nf) return nf.format(major);
      // fallback: holé číslo + ISO kód (lepší špatný oddělovač než špatná měna)
      return (
        new Intl.NumberFormat("cs-CZ").format(major) +
        " " +
        (P.currencyCode || "")
      ).trim();
    };
  })();

  // text expedice podle dne v týdnu (vždy čas Praha): Po–Čt „do 24 hodin",
  // Pá/So „hned v pondělí", Ne „již zítra"
  function shipNote() {
    const wd = new Date().toLocaleDateString("en-US", {
      timeZone: "Europe/Prague",
      weekday: "short",
    });
    if (wd === "Fri" || wd === "Sat") return T("ship_monday");
    if (wd === "Sun") return T("ship_tomorrow");
    return T("ship_24h");
  }

  // SOCIAL PROOF: z reálného čísla prodejů (metafield custom.sold_90d → P.sold90) vyrob text:
  //   - >= 1000  → „Tisíce prodaných kusů v poslední době"
  //   - >= 100   → „Stovky prodaných kusů v poslední době"
  //   - < 100    → štítek se SKRYJE (málo prodejů = neukazovat)
  //   - chybí metafield → ponecháme ručně zadaný text z nastavení (P.soldBadge / P.soldBadgeShort)
  (function computeSold() {
    const raw = P.sold90;
    if (raw == null || raw === "") return; // bez metafieldu → ponech text z nastavení sekce
    const n = parseInt(raw, 10);
    if (isNaN(n)) return;
    if (n >= 1000) {
      P.soldBadge = T("sold_thousands");
      P.soldBadgeShort = T("sold_thousands");
    } else if (n >= 100) {
      P.soldBadge = T("sold_hundreds");
      P.soldBadgeShort = T("sold_hundreds");
    } else {
      P.soldBadge = "";
      P.soldBadgeShort = "";
    }
  })();

  // REÁLNÉ RECENZE: z metafieldů custom.recenze_a/b/c (HTML) vytáhni citaci + autora.
  // Citace = text .rich-text__subheading (bez svg/animací), autor = .rich-text__text.
  function parseReviewHtml(html) {
    if (!html) return null;
    const d = document.createElement("div");
    d.innerHTML = html;
    const qEl = d.querySelector(".rich-text__subheading") || d.querySelector("p");
    const aEl = d.querySelector(".rich-text__text");
    if (!qEl) return null;
    const text = (qEl.textContent || "")
      .trim()
      .replace(/^[“”„"'\s]+|[“”„"'\s]+$/g, "")
      .trim();
    const author = aEl
      ? (aEl.textContent || "").trim().replace(/^[–—-]\s*/, "").trim()
      : "";
    if (!text) return null;
    return { text, author };
  }
  (function loadReviews() {
    const parsed = [P.reviewA, P.reviewB, P.reviewC].map(parseReviewHtml).filter(Boolean);
    if (parsed.length) P.quotes = parsed; // jinak zůstane fallback z nastavení sekce
  })();

  // PDP BADGE (metafield custom.pdp_badge): počet neprázdných řádků určuje roli, ať se nemusí
  // psát prázdné řádky. 1 = jen titulek; 2 = titulek + podtitulek; 3+ = eyebrow / titulek / podtitulek
  // (4.+ řádek se přilepí k podtitulku). Prázdné / bílé znaky → P.badge = null a vše zůstane jako dnes.
  (function parseBadge() {
    const raw = P.badge;
    P.badge = null;
    if (raw == null) return;
    const lines = String(raw).split(/\r?\n/).map((s) => s.trim()).filter(Boolean);
    if (!lines.length) return;
    if (lines.length === 1) P.badge = { title: lines[0] };
    else if (lines.length === 2) P.badge = { title: lines[0], sub: lines[1] };
    else P.badge = { eyebrow: lines[0], title: lines[1], sub: lines.slice(2).join(" ") };
  })();

  // kompletně vyprodané barvy (žádná dostupná velikost) seřaď na konec (doprava); jinak zachovej pořadí.
  // Bezpečné: availability/stock/variantIds se klíčují přes color.key, ne přes index.
  (function sortColorsBySoldOut() {
    if (!P.colors || !P.availability) return;
    const ok = (c) => Object.values(P.availability[c.key] || {}).some(Boolean);
    P.colors = P.colors
      .map((c, i) => ({ c, i, ok: ok(c) }))
      .sort((a, b) => (a.ok === b.ok ? a.i - b.i : a.ok ? -1 : 1))
      .map((x) => x.c);
  })();

  // dlouhý název produktu zmenši, ať zůstane na 1 řádku (min 24 px; když ani to nestačí, povol zalomení)
  function fitTitle() {
    $$("h1[data-title]").forEach((h) => {
      h.style.fontSize = "";
      h.style.whiteSpace = "nowrap";
      if (!h.clientWidth) {
        h.style.whiteSpace = "";
        return;
      }
      let fs = parseFloat(getComputedStyle(h).fontSize) || 40;
      let guard = 0;
      while (h.scrollWidth > h.clientWidth + 1 && fs > 24 && guard < 60) {
        fs -= 1;
        h.style.fontSize = fs + "px";
        guard++;
      }
      if (h.scrollWidth > h.clientWidth + 1) h.style.whiteSpace = ""; // ani na minimu se nevešel → povol zalomení
    });
  }

  // položka galerie může být string (obrázek) NEBO objekt { img, v } (v = mp4 zdroj videa)
  const gimg = (x) => (typeof x === "string" ? x : (x && x.img) || "");
  const gvid = (x) => (x && typeof x === "object" ? x.v : null);
  // bod fokusu z Shopify (image.presentation.focal_point → "50.0% 30.0%") pro object-position;
  // díky němu se fotka ořezává (cover) kolem zvoleného bodu, ne natvrdo na střed
  const gfp = (x) =>
    x && typeof x === "object" && x.fp ? x.fp : "";
  // vyrenderuje <video> (autoplay/muted/loop) pro video, jinak <img>
  function slideMedia(it, i, w, alt) {
    const v = gvid(it);
    const fp = gfp(it);
    const fpStyle = fp ? ` style="object-position:${fp}"` : "";
    if (v)
      return `<video class="mgal__video" src="${v}" poster="${gimg(it)}" muted loop playsinline autoplay preload="metadata" aria-label="${escapeHtml(alt || "")}"${fpStyle}></video>`;
    return `<img loading="${i === 0 ? "eager" : "lazy"}" decoding="async" src="${W(gimg(it), w)}" alt="${escapeHtml(alt || P.title)}"${fpStyle}>`;
  }
  // lokální cutout fotky vs. CDN lifestyle (jen CDN umí ?width)
  const isLocal = (s) => s.indexOf("cdn.shopify") === -1;
  const W = (s, w) => (isLocal(s) ? s : s + "&width=" + w);
  const heroSrc = () => {
    const g = P.colors[state.color].gallery;
    return gimg(g.find((s) => gimg(s).indexOf("cdn.shopify") > -1) || g[0]);
  };
  const reduced = () =>
    root().classList.contains("rm") ||
    (window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  // crossfade obsahu při změně barvy (respektuje reduced-motion)
  const swapFade = (el, render) => {
    if (reduced()) {
      render();
      return;
    }
    el.style.transition = "opacity " + "var(--dur,.45s)";
    el.style.opacity = "0";
    setTimeout(() => {
      render();
      el.style.opacity = "1";
    }, 260);
  };

  function discountFor(qty) {
    // robustní vůči pořadí prahů: ber nejvyšší slevu mezi vyhovujícími (ne „poslední v poli")
    let best = { min: 1, pct: 0 };
    for (const d of P.discounts) if (qty >= d.min && d.pct >= best.pct) best = d;
    return best;
  }
  function unitPrice(qty) {
    // v předplatném je sleva plošná (15 %), ne množstevní žebřík
    if (subActive()) return P.price * (1 - SUBP.pct / 100);
    return P.price * (1 - discountFor(qty).pct / 100);
  }
  function totalPrice(qty) {
    return unitPrice(qty) * qty;
  }

  /* ---------- SWATCHE ---------- */
  function renderSwatches(el) {
    function paint() {
      el.innerHTML = P.colors
        .map((c, i) => {
          const sel = i === state.color ? " is-active" : "";
          const soldout = Object.values(P.availability[c.key]).some(Boolean) ? "" : " is-soldout";
          // exkluzivní barva v jednorázovém režimu → široký „pill" s popiskem (ne kryptická ikona)
          // sděl SR i vyprodanost (sám vizuální stav nestačí); escapuj názvy barev do atributů
          const soName = soldout ? " – " + T("soldout_btn") : "";
          const eName = escapeHtml(c.name);
          const eSub = escapeHtml(c.sub);
          if (subEnabled && c.subOnly && !subActive()) {
            return `<button class="swatch swatch--excl${sel}${soldout}" type="button" data-i="${i}" aria-pressed="${i === state.color}" aria-label="${eName} — pouze v předplatném${soName}" title="${eName} — pouze v předplatném"><span class="swatch__dot" style="background:${c.swatch}"></span><span class="swatch__excl">Pouze v předplatném</span></button>`;
          }
          return `<button class="swatch${sel}${soldout}" type="button" data-i="${i}" style="background:${c.swatch}" aria-pressed="${i === state.color}" aria-label="${eName} ${eSub}${soName}" title="${eName} | ${eSub}"></button>`;
        })
        .join("");
    }
    el.addEventListener("click", (e) => {
      const b = e.target.closest("[data-i]");
      if (!b) return;
      const i = parseInt(b.dataset.i, 10);
      const c = P.colors[i];
      // exkluzivní barva automaticky přepne na předplatné (+ vysvětlení toastem)
      if (subEnabled && c.subOnly && state.mode !== "sub") {
        state.mode = "sub";
        toast(`${c.name} pošleme jen v pravidelném posílání — zapnula jsem ti ho 🤍`);
      }
      state.color = i;
      // velikost ZACHOVÁME i při změně barvy — když je v nové barvě vyprodaná,
      // zůstane vybraná a ukáže se vyprodaný stav (Restock Rocket), ne falešná cena
      emit();
    });
    paint();
    // překresli jen při změně barvy/režimu (ne při qty/velikosti)
    let lc = state.color, lm = state.mode;
    onChange(() => {
      if (state.color === lc && state.mode === lm) return;
      lc = state.color;
      lm = state.mode;
      paint();
    });
  }

  /* ---------- HERO OBRÁZEK (varianta B) ---------- */
  function bindHeroImg() {
    $$("[data-hero-img]").forEach((img) => {
      let lastColor = -1;
      onChange(() => {
        if (state.color === lastColor) return;
        lastColor = state.color;
        const src = W(heroSrc(), 1600); // lifestyle, ne cutout
        if (img.getAttribute("src") === src) return;
        img.style.transition = "opacity .35s var(--ease)";
        img.style.opacity = "0";
        const done = () => {
          img.style.opacity = "";
        };
        img.onload = done;
        img.onerror = done;
        img.src = src;
      });
    });
  }

  /* ---------- NÁZEV BARVY ---------- */
  function renderColorName(el) {
    const c = P.colors[state.color];
    el.innerHTML = `<b>${escapeHtml(c.name)}</b> <span>· ${escapeHtml(c.sub)}</span>`;
  }

  /* ---------- GALERIE ---------- */
  function buildGallery(el) {
    const track = document.createElement("div");
    track.className = "gallery__track";
    const dots = document.createElement("div");
    dots.className = "gallery__dots";
    const count = document.createElement("div");
    count.className = "gallery__count";
    const prev = document.createElement("button");
    prev.className = "gallery__nav gallery__nav--prev";
    prev.innerHTML = "‹";
    prev.setAttribute("aria-label", T("aria_prev_photo"));
    const next = document.createElement("button");
    next.className = "gallery__nav gallery__nav--next";
    next.innerHTML = "›";
    next.setAttribute("aria-label", T("aria_next_photo"));
    el.append(track, dots, count, prev, next);

    function paint() {
      const imgs = P.colors[state.color].gallery;
      track.innerHTML = "";
      dots.innerHTML = "";
      imgs.forEach((src, i) => {
        const s = document.createElement("div");
        s.className =
          "gallery__slide" + (isLocal(gimg(src)) ? " gallery__slide--contain" : "");
        const img = document.createElement("img");
        img.loading = i === 0 ? "eager" : "lazy";
        img.src = W(gimg(src), 1000);
        img.alt = P.title + " – " + P.colors[state.color].name;
        s.appendChild(img);
        track.appendChild(s);
        const d = document.createElement("i");
        if (i === 0) d.classList.add("is-active");
        dots.appendChild(d);
      });
      track.scrollLeft = 0;
      count.textContent = "1/" + imgs.length;
    }
    function activeIndex() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    track.addEventListener(
      "scroll",
      () => {
        const idx = activeIndex();
        $$("i", dots).forEach((d, i) => d.classList.toggle("is-active", i === idx));
        count.textContent = idx + 1 + "/" + track.children.length;
      },
      { passive: true }
    );
    const go = (dir) =>
      track.scrollBy({ left: dir * track.clientWidth, behavior: "smooth" });
    prev.addEventListener("click", () => go(-1));
    next.addEventListener("click", () => go(1));

    // crossfade jen při změně barvy (ne při velikosti/množství)
    let lastColor = state.color;
    paint();
    onChange(() => {
      if (state.color === lastColor) return;
      lastColor = state.color;
      swapFade(track, paint);
    });

    // sync thumbs (pokud existují)
    return { paint, track };
  }

  function renderThumbs(el, gallery) {
    function paint() {
      const imgs = P.colors[state.color].gallery;
      el.innerHTML = "";
      imgs.forEach((src, i) => {
        const b = document.createElement("button");
        if (i === 0) b.classList.add("is-active");
        const img = document.createElement("img");
        img.src = W(gimg(src), 120);
        img.loading = "lazy";
        b.appendChild(img);
        b.addEventListener("click", () => {
          gallery.track.scrollTo({ left: i * gallery.track.clientWidth, behavior: "smooth" });
          $$("button", el).forEach((x, j) => x.classList.toggle("is-active", j === i));
        });
        el.appendChild(b);
      });
    }
    gallery.track.addEventListener(
      "scroll",
      () => {
        const idx = Math.round(gallery.track.scrollLeft / gallery.track.clientWidth);
        $$("button", el).forEach((x, j) => x.classList.toggle("is-active", j === idx));
      },
      { passive: true }
    );
    paint();
    onChange(paint);
  }

  /* ---------- GALERIE MOZAIKA (benefity v galerii, à la CANS) ---------- */
  function buildMosaic(el) {
    let tiles = P.galleryTiles || [];
    // data-tiles="leaf,heart" → omezí dlaždice na vyjmenované ikony (D-4r: bez Oeko-Tex)
    if (el.dataset.tiles) {
      const want = el.dataset.tiles.split(",").map((s) => s.trim());
      tiles = tiles.filter((t) => want.includes(t.icon));
    }
    const mode = el.dataset.mosaic;
    const swipe = mode === "swipe" || mode === "swipe-back";
    const back = mode === "swipe-back"; // swipe + na desktopu navíc lifestyle (zadní) fotka
    const compact = mode === "compact" || swipe;
    const cap = el.hasAttribute("data-mosaic-cap"); // název+cena jako overlay ve fotce (mobil)
    const tileVideo = el.getAttribute("data-tile-video"); // video pattern na pozadí dlaždice „Ušito v ČR"
    const swapCR = el.hasAttribute("data-swap-review"); // prohodit dlaždici ČR a recenzi
    const mtileHTML = (t) => {
      const vid = tileVideo && !reduced() && /ČR/.test(t.title);
      return `<div class="mtile${vid ? " mtile--video" : ""}">${
        vid
          ? `<video class="mtile__bg" src="${tileVideo}" autoplay muted loop playsinline></video>`
          : ""
      }${icon(t.icon)}<b>${t.title}</b><small>${t.sub}</small></div>`;
    };
    const crTile = tiles.find((t) => /ČR/.test(t.title));
    const ratingsTile = el.hasAttribute("data-ratings-tile"); // 3. USP dlaždice = ukazatele z recenzí (D-4r)
    const reviewQuote = el.hasAttribute("data-review-quote"); // citaci do recenzní dlaždice
    const lifeRevFirst = el.hasAttribute("data-life-rev-first"); // prohodit spodní dlaždice (recenze vlevo)
    if (reviewQuote) el.classList.add("mosaic--rq");
    const countAuto = el.hasAttribute("data-count-auto"); // počítadlo skryté, ukáže se jen při swipu
    const capReview = el.getAttribute("data-cap-review"); // "bottom" | "topleft" — hodnocení do fotky (mobil)
    if (capReview) el.classList.add("mosaic--caprev");
    // badge (metafield) přebíjí štítek „prodáno": rating zůstává, místo sold pillu je promo pill
    // (titulek) + jemný spodní řádek (eyebrow · podtitulek). Bez badge = původní chování.
    const badgeSubLine = P.badge
      ? [P.badge.eyebrow, P.badge.sub].filter(Boolean).join(" · ")
      : "";
    const capRevHTML = !capReview
      ? ""
      : P.badge
        ? `<div class="mgal__rev mgal__rev--${capReview}"><b>${P.rating.toFixed(1).replace(".",",")}</b> <span class="mgal__stars">★</span> <span class="mgal__promo"><span class="mgal__promodot" aria-hidden="true"></span>${escapeHtml(P.badge.title)}</span>${badgeSubLine ? ` <span class="mgal__promosub">${escapeHtml(badgeSubLine)}</span>` : ""}</div>`
        : `<div class="mgal__rev mgal__rev--${capReview}"><b>${P.rating.toFixed(1).replace(".",",")}</b> <span class="mgal__stars">★</span>${P.soldBadge ? ` <span class="mgal__soldin">${FLAME}${P.soldBadge}</span>` : ""}</div>`;
    if (compact) el.classList.add("mosaic--compact");
    if (swipe && !back) el.classList.add("mosaic--swipe");
    if (cap) el.classList.add("mosaic--cap");
    // badge (metafield) nahradí celou recenzní dlaždici. Ponecháváme třídu mosaic__cell--review,
    // aby zůstala beze změny mřížka (stretch přes mosaic--rq) i animColor (bere foto = :not(--review)).
    const badgeCell = () =>
      `<div class="mosaic__cell mosaic__cell--review mosaic__cell--badge">
        ${P.badge.eyebrow ? `<span class="mbadge__eyebrow"><span class="mbadge__dot" aria-hidden="true"></span>${escapeHtml(P.badge.eyebrow)}</span>` : ""}
        <span class="mbadge__title">${escapeHtml(P.badge.title)}</span>
        ${P.badge.sub ? `<span class="mbadge__sub">${escapeHtml(P.badge.sub)}</span>` : ""}
      </div>`;
    const reviewCell = () =>
      P.badge
        ? badgeCell()
        : reviewQuote
        ? `<div class="mosaic__cell mosaic__cell--review mosaic__cell--review-q">
            <div class="mrev__head"><span class="mrev__stars">${starStr(Math.round(P.rating))}</span> <b class="mrev__score">${P.rating.toFixed(1).replace(".",",")}</b></div>
            ${P.soldBadge ? `<span class="mrev__sold">${FLAME}${P.soldBadge}</span>` : ""}
            <p class="mrev__quote">„${P.quotes[0].text}“<cite>— ${P.quotes[0].author}</cite></p>
          </div>`
        : `<div class="mosaic__cell mosaic__cell--review">
            <div class="mrev__stars">${starStr(Math.round(P.rating))}</div>
            <b class="mrev__score">${P.rating.toFixed(1).replace(".",",")}<span> / 5</span></b>
            <small>${T("reviews_count", { n: P.reviewCount })}</small>
          </div>`;

    // hlavní fotka: buď statická, nebo (swipe) carousel přes celou galerii barvy
    function mainHTML(g) {
      if (!swipe)
        return `<div class="mosaic__main${gvid(g[0]) ? "" : isLocal(gimg(g[0])) ? " mosaic__main--contain" : ""}">${slideMedia(g[0], 0, 1100, P.title)}</div>`;
      const name = P.colors[state.color].name;
      return `<div class="mosaic__main mgal">
        <div class="mgal__track" data-mgal-track tabindex="0" role="group" aria-roledescription="carousel" aria-label="${T("aria_gallery", { name })}">
          ${g
            .map(
              (it, i) =>
                `<div class="mgal__slide" role="group" aria-roledescription="slide" aria-label="${T("aria_slide", { i: i + 1, n: g.length })}">${slideMedia(it, i, 1100, P.title + " – " + name)}</div>`
            )
            .join("")}
        </div>
        ${g.length > 1 ? `<div class="gallery__count${countAuto ? " gallery__count--auto" : ""}" data-mgal-count>1/${g.length}</div>
        <div class="mgal__dots" data-mgal-dots>${g
          .map(
            (_, i) =>
              `<button class="mgal__dot${i === 0 ? " is-active" : ""}" aria-label="Foto ${i + 1}"></button>`
          )
          .join("")}</div>
        <button class="gallery__nav gallery__nav--prev" data-mgal-prev aria-label="${T("aria_prev_photo")}">‹</button>
        <button class="gallery__nav gallery__nav--next" data-mgal-next aria-label="${T("aria_next_photo")}">›</button>` : ""}
        <div class="visually-hidden" aria-live="polite" data-mgal-live></div>
        ${capReview === "topleft" ? capRevHTML : ""}
        ${cap ? `<div class="mgal__cap"><div class="mgal__title"></div><div class="price"><span class="price__now" data-price-now></span><span class="price__old" data-price-old></span><span class="price__tags"><span class="price__save" data-price-save></span><span class="price__yearlow">${T("price_yearlow")}</span></span></div>${capReview === "bottom" ? capRevHTML : ""}</div>` : ""}
      </div>`;
    }
    function fillCap(root) {
      if (!cap) return;
      root = root || el;
      const t = $(".mgal__title", root);
      if (t) t.textContent = P.title;
      const unit = unitPrice(state.qty);
      const now = $(".mgal__cap [data-price-now]", root);
      const old = $(".mgal__cap [data-price-old]", root);
      const save = $(".mgal__cap [data-price-save]", root);
      if (now) now.textContent = fmt(unit);
      if (old) old.textContent = fmt(P.compareAt);
      if (save)
        save.textContent = "−" + Math.round((1 - unit / P.compareAt) * 100) + " %";
    }
    function wireCarousel() {
      if (!swipe) return;
      const track = $("[data-mgal-track]", el);
      if (!track) return;
      const dots = $$(".mgal__dot", el);
      const count = $("[data-mgal-count]", el);
      const live = $("[data-mgal-live]", el);
      const n = track.children.length;
      let hideT;
      // pozice slidu = jeho skutečné offsetLeft (ne i*clientWidth) – imunní vůči sub-pixel
      // šířkám, takže navigace vždy dorolujeme přesně na hranu fotky a žádná sousední nevykoukne.
      const slideLeft = (i) =>
        track.children[i] ? track.children[i].offsetLeft : i * track.clientWidth;
      const currentIdx = () => {
        let best = 0,
          bestD = Infinity;
        for (let i = 0; i < n; i++) {
          const d = Math.abs(slideLeft(i) - track.scrollLeft);
          if (d < bestD) {
            bestD = d;
            best = i;
          }
        }
        return best;
      };
      const update = () => {
        const idx = currentIdx();
        dots.forEach((d, i) => d.classList.toggle("is-active", i === idx));
        if (count) count.textContent = idx + 1 + "/" + n;
        if (live) live.textContent = "Foto " + (idx + 1) + " z " + n;
        if (countAuto && count) {
          count.classList.add("is-show");
          clearTimeout(hideT);
          hideT = setTimeout(() => count.classList.remove("is-show"), 1300);
        }
      };
      track.addEventListener("scroll", update, { passive: true });
      const scrollToIdx = (i) => {
        i = Math.max(0, Math.min(n - 1, i));
        const left = slideLeft(i);
        if (track.scrollTo) track.scrollTo({ left, behavior: "smooth" });
        else track.scrollLeft = left;
      };
      const go = (dir) => scrollToIdx(currentIdx() + dir);
      dots.forEach((d, i) => d.addEventListener("click", () => scrollToIdx(i)));
      const prev = $("[data-mgal-prev]", el);
      const next = $("[data-mgal-next]", el);
      if (prev) prev.addEventListener("click", () => go(-1));
      if (next) next.addEventListener("click", () => go(1));
      track.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") {
          go(-1);
          e.preventDefault();
        } else if (e.key === "ArrowRight") {
          go(1);
          e.preventDefault();
        }
      });
    }

    // zmenši písmo sold-badge tak, aby byl na 1 řádek a shape ho obepnul (nikdy nepřeteče);
    // když ani na min. velikosti (11px) na 1 řádek nevejde, radši zalom než přetékej
    function fitSoldBadges() {
      $$(".mrev__sold, .mgal__soldin", el).forEach((b) => {
        b.style.fontSize = "";
        b.style.whiteSpace = "nowrap";
        if (!b.clientWidth) return;
        let fs = parseFloat(getComputedStyle(b).fontSize) || 13;
        let guard = 0;
        while (b.scrollWidth > b.clientWidth + 1 && fs > 11 && guard < 40) {
          fs -= 0.5;
          b.style.fontSize = fs + "px";
          guard++;
        }
        if (b.scrollWidth > b.clientWidth + 1) b.style.whiteSpace = "normal";
      });
    }
    function build() {
      const g = P.colors[state.color].gallery;
      // desktop/tablet: 2. fotka NENÍ v horní galerii, jen v dolní foto-dlaždici.
      // mobil: dolní foto-dlaždice se skrývá CSS → 2. fotka zůstává normálně v galerii.
      // jen 1 fotka → žádná foto-dlaždice (recenze se roztáhne přes celou šířku).
      const twoRow = window.innerWidth >= 768 && !(swipe && !back);
      const hasTilePhoto = twoRow && g.length > 1;
      const carImgs = hasTilePhoto ? g.filter((_, i) => i !== 1) : g;
      el._carImgs = carImgs;
      el._carExcl = hasTilePhoto ? 1 : -1; // index fotky vyřazené z horní galerie (= dolní dlaždice)
      const photoCell = hasTilePhoto
        ? `<div class="mosaic__cell">${slideMedia(g[1], 1, 700, "")}</div>`
        : "";
      // při swapCR je v sloupci USP místo dlaždice ČR recenze a dlaždice ČR (s vlajkou) putuje dolů
      const benefits =
        mainHTML(carImgs) +
        `<div class="mosaic__benefits">${tiles
          .map((t) => {
            if (ratingsTile && /Oeko/.test(t.title))
              return `<div class="mtile mtile--ratings"><b class="mtile__rtitle">Co na tom zákaznice milují</b>${ratingBarsHTML()}</div>`;
            return swapCR && t === crTile ? reviewCell() : mtileHTML(t);
          })
          .join("")}</div>`;
      const lifeMain = swapCR ? mtileHTML(crTile) : reviewCell();
      el.innerHTML =
        benefits +
        `<div class="mosaic__life">${
          swipe && !back
            ? lifeMain
            : lifeRevFirst
              ? `${lifeMain}${photoCell}`
              : `${photoCell}${lifeMain}`
        }</div>`;
      wireCarousel();
      fillCap();
      fitSoldBadges();
    }

    // Změna barvy: benefit dlaždice i recenze jsou pro všechny barvy stejné, tak je NEpřekreslujeme.
    // Animujeme jen fotky (hlavní galerie + spodní foto-dlaždici). Když se mění počet fotek
    // (2 fotky ↔ 1 fotka), navíc plynule srolujeme výšku spodního řádku, aby se „blok" smrskl/narostl.
    function animColor() {
      if (reduced()) {
        build();
        return;
      }
      const g = P.colors[state.color].gallery;
      const twoRow = window.innerWidth >= 768 && !(swipe && !back);
      const hasTilePhoto = twoRow && g.length > 1;
      const carImgs = hasTilePhoto ? g.filter((_, i) => i !== 1) : g;
      const life = $(".mosaic__life", el);
      const oldMain = $(".mosaic__main", el);
      const oldCell = life
        ? $(".mosaic__cell:not(.mosaic__cell--review)", life)
        : null;
      if (!oldMain) {
        build();
        return;
      }
      const hadTilePhoto = el._carExcl >= 0; // měnil se počet fotek (2↔1)?
      const layoutChange = hadTilePhoto !== hasTilePhoto;
      el._carImgs = carImgs;
      el._carExcl = hasTilePhoto ? 1 : -1;

      // pravý crossfade: novou fotku polož absolutně PŘES starou (stejný box) a přelij ji.
      // Stará je vespod vidět celou dobu → žádný prázdný frame (= žádné probliknutí), žádné scale.
      const crossfade = (host, fresh, after) => {
        host.style.position = "relative";
        fresh.style.cssText = "position:absolute;inset:0;opacity:0;z-index:2";
        host.appendChild(fresh);
        requestAnimationFrame(() => {
          fresh.style.transition = "opacity .3s ease";
          fresh.style.opacity = "1";
        });
        setTimeout(() => {
          fresh.style.cssText = "";
          host.style.position = "";
          host.replaceWith(fresh);
          if (after) after();
        }, 340);
      };

      // 1) hlavní galerie – crossfade JEN fotek (track). Ovládací prvky (tečky, počítadlo,
      //    šipky, popisek) vyměníme natvrdo, ať se nepřekrývají a needeformují. Vnější
      //    .mosaic__main zůstává; výšku drží layout buňky (desktop: height:100% výšky řádku;
      //    mobil/tablet: aspect-ratio) + overflow-y:hidden, takže galerie se nehne (žádný zámek
      //    výšky – ten kvůli zaokrouhlení offsetHeight cukal nahoru/dolů).
      const tmp = document.createElement("div");
      tmp.innerHTML = mainHTML(carImgs);
      const newMain = tmp.firstElementChild;
      fillCap(newMain);
      const oldTrack = $("[data-mgal-track]", oldMain);
      const newTrack = newMain.querySelector("[data-mgal-track]");
      // ovládací prvky (vše kromě tracku) vyměň okamžitě – jediná sada teček, žádné překrytí
      Array.prototype.slice
        .call(oldMain.children)
        .forEach((c) => {
          if (c !== oldTrack) c.remove();
        });
      Array.prototype.slice.call(newMain.children).forEach((c) => {
        if (c !== newTrack) oldMain.appendChild(c);
      });
      // přelij přes sebe jen fotky (track je absolutní z CSS → žádné přepínání pozice)
      if (oldTrack && newTrack) {
        newTrack.style.opacity = "0";
        oldMain.appendChild(newTrack);
        requestAnimationFrame(() => {
          newTrack.style.transition = "opacity .3s ease";
          newTrack.style.opacity = "1";
        });
      } else if (newTrack) {
        if (oldTrack) oldTrack.remove();
        oldMain.appendChild(newTrack);
      }
      setTimeout(() => {
        if (oldTrack) oldTrack.remove();
        if (newTrack) {
          newTrack.style.opacity = "";
          newTrack.style.transition = "";
        }
        oldMain.classList.toggle(
          "mosaic__main--contain",
          newMain.classList.contains("mosaic__main--contain")
        );
        wireCarousel();
        fillCap();
        fitSoldBadges();
      }, 340);

      // 2) spodní foto-dlaždice
      if (life) {
        if (hasTilePhoto && oldCell) {
          // stejný layout (obě barvy mají 2. fotku) → jen crossfade dlaždice, výška se nemění
          const t2 = document.createElement("div");
          t2.innerHTML = `<div class="mosaic__cell">${slideMedia(g[1], 1, 700, "")}</div>`;
          crossfade(oldCell, t2.firstElementChild);
        } else if (layoutChange) {
          // mění se počet dlaždic (2↔1) → přidej/odeber a plynule animuj výšku řádku
          const lifeH0 = life.offsetHeight;
          let newCell = null;
          if (hasTilePhoto) {
            const t2 = document.createElement("div");
            t2.innerHTML = `<div class="mosaic__cell">${slideMedia(g[1], 1, 700, "")}</div>`;
            newCell = t2.firstElementChild;
            newCell.style.opacity = "0";
            if (lifeRevFirst) life.appendChild(newCell);
            else life.insertBefore(newCell, life.firstChild);
          } else if (oldCell) {
            oldCell.remove();
          }
          const lifeH1 = life.offsetHeight;
          if (Math.abs(lifeH1 - lifeH0) > 2) {
            life.style.overflow = "hidden";
            life.style.height = lifeH0 + "px";
            life.offsetHeight; // reflow
            life.style.transition = "height .4s ease";
            life.style.height = lifeH1 + "px";
            setTimeout(() => {
              life.style.height = "";
              life.style.transition = "";
              life.style.overflow = "";
            }, 460);
          }
          if (newCell)
            requestAnimationFrame(() => {
              newCell.style.transition = "opacity .3s ease";
              newCell.style.opacity = "1";
            });
        }
      }
    }

    // klik na fotku → fullscreen lightbox (delegovaně, ať přežije překreslení galerie).
    // Lightbox vždy ukazuje PLNOU galerii barvy; jen dopočítáme správný index.
    el.addEventListener("click", (e) => {
      if (!e.target.closest("img")) return;
      const g = P.colors[state.color].gallery;
      const excl = el._carExcl != null ? el._carExcl : -1;
      const main = e.target.closest(".mosaic__main");
      if (main) {
        const track = $("[data-mgal-track]", el);
        let carIdx =
          track && track.clientWidth
            ? Math.round(track.scrollLeft / track.clientWidth)
            : 0;
        // carousel vynechává fotku `excl` → přemapuj na index v plné galerii
        const fullIdx = excl >= 0 && carIdx >= excl ? carIdx + 1 : carIdx;
        openLightbox(g, fullIdx);
        return;
      }
      // dolní lifestyle dlaždice (ne recenze) → otevři na té fotce
      const cell = e.target.closest(".mosaic__cell");
      if (cell && !cell.classList.contains("mosaic__cell--review")) {
        openLightbox(g, excl >= 0 ? excl : 0);
      }
    });

    let lastColor = state.color;
    build();
    // po načtení webfontu přeměř: na fallback fontu se badge vejde, brandový font je širší → jinak přeteče
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSoldBadges);
    onChange(() => {
      if (state.color === lastColor) return;
      lastColor = state.color;
      animColor();
    });
    // resize: při přechodu mobil↔desktop překresli (mění se rozdělení galerie/dlaždice),
    // jinak jen dopočítej velikost štítku
    let lastMobile = window.innerWidth < 768;
    window.addEventListener(
      "resize",
      () => {
        const m = window.innerWidth < 768;
        if (m !== lastMobile) {
          lastMobile = m;
          build();
        } else {
          fitSoldBadges();
        }
      },
      { passive: true }
    );
  }

  /* ---------- LIGHTBOX (fullscreen galerie) ---------- */
  let _lb;
  function lbTrack() {
    return _lb ? _lb.querySelector("[data-lb-track]") : null;
  }
  function lbCount() {
    const tr = lbTrack();
    if (!tr) return;
    const c = _lb.querySelector("[data-lb-count]");
    if (c) c.textContent = Math.round(tr.scrollLeft / tr.clientWidth) + 1 + "/" + tr.children.length;
  }
  function lbGo(dir) {
    const tr = lbTrack();
    if (!tr) return;
    const idx = Math.round(tr.scrollLeft / tr.clientWidth) + dir;
    const t = Math.max(0, Math.min(tr.children.length - 1, idx));
    if (tr.scrollTo) tr.scrollTo({ left: t * tr.clientWidth, behavior: "smooth" });
    else tr.scrollLeft = t * tr.clientWidth;
  }
  let _lbLastFocus = null; // a11y: prvek, na který se po zavření lightboxu vrátí fokus
  function openLightbox(images, startIdx) {
    if (!images || !images.length) return;
    startIdx = startIdx || 0;
    if (!_lb) {
      _lb = document.createElement("div");
      _lb.className = "nebe-lightbox";
      // a11y: modální dialog — pomocné technologie ho oznámí a izolují od pozadí
      _lb.setAttribute("role", "dialog");
      _lb.setAttribute("aria-modal", "true");
      _lb.setAttribute("aria-label", T("aria_gallery", { name: P.title }));
      _lb.innerHTML =
        '<button class="nebe-lightbox__close" type="button" aria-label="' + T("lightbox_close") + '">×</button>' +
        '<button class="nebe-lightbox__nav nebe-lightbox__nav--prev" type="button" aria-label="' + T("lightbox_prev") + '">‹</button>' +
        '<button class="nebe-lightbox__nav nebe-lightbox__nav--next" type="button" aria-label="' + T("lightbox_next") + '">›</button>' +
        '<div class="nebe-lightbox__track" data-lb-track></div>' +
        '<div class="nebe-lightbox__count" data-lb-count></div>';
      document.body.appendChild(_lb);
      const close = () => {
        _lb.classList.remove("is-open");
        document.documentElement.style.overflow = "";
        // a11y: vrať fokus na prvek, ze kterého byl lightbox otevřen
        if (_lbLastFocus && _lbLastFocus.focus) _lbLastFocus.focus();
        _lbLastFocus = null;
      };
      _lb.querySelector(".nebe-lightbox__close").addEventListener("click", close);
      _lb.addEventListener("click", (e) => {
        if (e.target === _lb) close();
      });
      _lb.querySelector(".nebe-lightbox__nav--prev").addEventListener("click", () => lbGo(-1));
      _lb.querySelector(".nebe-lightbox__nav--next").addEventListener("click", () => lbGo(1));
      _lb.querySelector("[data-lb-track]").addEventListener("scroll", lbCount, { passive: true });
      // klik mimo samotnou fotku (do tmavého pozadí) → zavře lightbox
      _lb.querySelector("[data-lb-track]").addEventListener("click", (e) => {
        if (!e.target.closest("img")) close();
      });
      document.addEventListener("keydown", (e) => {
        if (!_lb.classList.contains("is-open")) return;
        if (e.key === "Escape") close();
        else if (e.key === "ArrowLeft") lbGo(-1);
        else if (e.key === "ArrowRight") lbGo(1);
        else if (e.key === "Tab") {
          // a11y: uvězni Tab uvnitř lightboxu (jen ovládací tlačítka jsou fokusovatelná)
          const f = $$("button", _lb).filter((b) => b.offsetParent !== null);
          if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          } else if (!_lb.contains(document.activeElement)) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    }
    const track = lbTrack();
    track.innerHTML = images
      .map(
        (src) =>
          '<div class="nebe-lightbox__slide">' + slideMedia(src, 0, 2000, P.title) + "</div>"
      )
      .join("");
    // a11y: zapamatuj spouštěč a po otevření přesuň fokus dovnitř (na zavírací tlačítko)
    _lbLastFocus = document.activeElement;
    _lb.classList.add("is-open");
    document.documentElement.style.overflow = "hidden"; // zamkni scroll pozadí
    const closeBtn = _lb.querySelector(".nebe-lightbox__close");
    if (closeBtn && closeBtn.focus) closeBtn.focus();
    // skoč na zvolenou fotku (bez animace) + dopočítej počítadlo
    requestAnimationFrame(() => {
      track.scrollLeft = startIdx * track.clientWidth;
      lbCount();
    });
  }

  /* ---------- FIT-HINT: pomocné funkce (QW-A0) ---------- */
  // Směr fitu řídí, JESTLI a JAKÉ vodítko ukázat. Zdroj: metafield custom.fit_advice
  // ("runs_small" | "true_to_size" | "runs_large"); když chybí, odvodíme z typu produktu.
  // Podprsenky/braletky/crop topy = "runs_small" (data: výměny dominují „o velikost větší").
  // Kalhotky/boxerky (vratkovost 1–4,6 %) zůstanou BEZ hintu — žádné falešné „vol větší".
  function fitDirection() {
    if (P.fitAdvice) return P.fitAdvice;
    const t = (P.productType || P.title || "").toLowerCase();
    if (/podprsenk|bralet|braletka|crop/.test(t)) return "runs_small";
    return null;
  }
  // A/B: stabilní per-návštěvník (localStorage). Holdout (default 10 %) nevidí nic → čistý holdout
  // pro měření dopadu na vratkovost. Globální vypnutí přes nastavení sekce (P.fitHintEnabled=false).
  function fitBucket() {
    if (P.fitHintEnabled === false) return "off";
    try {
      const k = "nebe_fit_ab";
      let v = localStorage.getItem(k);
      if (!v) {
        const holdout = (typeof P.fitHintHoldout === "number" ? P.fitHintHoldout : 10) / 100;
        v = Math.random() < holdout ? "holdout" : "on";
        localStorage.setItem(k, v);
      }
      return v;
    } catch (e) {
      return "on";
    }
  }
  // Leading-proxy měření (vratka má latenci 14–30 dní): posíláme do dataLayer (GTM) i volitelného
  // window.nebeTrack. Klíčové eventy: size_select (obě větve → posun rozložení velikostí),
  // fit_hint_view, fit_hint_expand (jen treatment).
  function track(ev, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: "nebe_" + ev, product: P.title }, data || {}));
      if (typeof window.nebeTrack === "function") window.nebeTrack(ev, data || {});
    } catch (e) {}
  }

  /* ---------- VELIKOSTI ---------- */
  function renderSizes(el) {
    const hint = el.parentElement.querySelector("[data-size-hint]");
    const advice = fitDirection();
    const bucket = fitBucket();
    const showFit = !!advice && bucket === "on";
    let fitBuilt = false;
    let fitViewed = false;

    // jednorázově poskládá obsah slotu [data-size-hint]: rozměr velikosti (VŠECHNY produkty)
    // + u fit-rizikových navíc rozbalovací mini-průvodce
    function buildHint() {
      if (!hint || fitBuilt) return;
      fitBuilt = true;
      let html = '<span class="size-measure" data-size-measure></span>';
      if (showFit) {
        hint.classList.add("fit");
        html +=
        '<span class="fit__line" data-fit-line></span>' +
        '<button type="button" class="fit__toggle" data-fit-toggle aria-expanded="false">' +
        T("fit_guide_toggle") +
        "</button>" +
        '<div class="fit__guide" data-fit-guide hidden>' +
        "<ul><li>" +
        T("fit_guide_b1") +
        "</li>" +
        (advice === "runs_small" ? "<li>" + T("fit_guide_b2") + "</li>" : "") +
        '<li><a data-fit-sizeopen>' +
        T("fit_guide_b3_link") +
        "</a></li></ul>" +
        '<p class="fit__gift">' +
        T("fit_gift_line") +
        "</p></div>";
      }
      hint.innerHTML = html;
      if (!showFit) return;
      const tgl = hint.querySelector("[data-fit-toggle]");
      const guide = hint.querySelector("[data-fit-guide]");
      tgl.addEventListener("click", () => {
        const opening = guide.hasAttribute("hidden");
        if (opening) {
          guide.removeAttribute("hidden");
          track("fit_hint_expand", { advice });
        } else {
          guide.setAttribute("hidden", "");
        }
        tgl.setAttribute("aria-expanded", opening ? "true" : "false");
      });
      // odkaz „tabulka rozměrů" → otevři existující modal velikostí (binding na [data-size-open]
      // proběhl při initu; náš prvek vznikl později, proto spustíme klik na hlavičkový odkaz)
      hint.querySelectorAll("[data-fit-sizeopen]").forEach((a) =>
        a.addEventListener("click", (e) => {
          e.preventDefault();
          const head = document.querySelector(".sizes-head [data-size-open]") || $("[data-size-open]");
          if (head) head.click();
        })
      );
    }

    // rozměr vybrané velikosti: primárně VŠECHNY parametry z přiřazené tabulky (SIZE_MEASURES),
    // popisky i hodnoty čistě z ní. Bez vybrané velikosti prázdné. Fallback (produkt bez
    // přiřazené tabulky): původní jedna hodnota z P.sizeHips + popisek z dat/locale.
    function paintMeasure() {
      const mEl = hint && hint.querySelector("[data-size-measure]");
      if (!mEl) return;
      if (state.size && SIZE_MEASURES && SIZE_MEASURES[state.size]) {
        mEl.textContent = SIZE_MEASURES[state.size]
          .map((p) => (p.label ? p.label + " " : "") + p.value)
          .join(" · ");
        return;
      }
      // POZN. (latentní): fallback bere hodnotu z P.sizeHips a popisek z type-aware
      // P.sizeMeasureLabel (bust/chest/hips dle metafieldu). Drobná pojistka: pokud
      // by Liquid někdy poslal hip-hodnoty bez odpovídajícího labelu, ukáže se obecný
      // „Boky" (locale) — nikdy NEpárujeme hardcoded HIP čísla s bust/chest labelem.
      const measure = state.size && P.sizeHips && P.sizeHips[state.size];
      const mlabel = P.sizeMeasureLabel || T("size_measure_label");
      mEl.textContent = measure ? (mlabel ? mlabel + " " : "") + measure : "";
    }

    // text vodítka reaguje na výběr: když zákaznice klikne na NEJMENŠÍ dostupnou velikost,
    // jemně připomeneme „o číslo větší" přesně tam, kde se posun děje (bez nagování ostatních).
    function paintFitLine() {
      const lineEl = hint && hint.querySelector("[data-fit-line]");
      if (!lineEl) return;
      const av = P.availability[P.colors[state.color].key];
      const firstAvail = P.sizes.find((s) => av[s]);
      let txt =
        advice === "runs_small" ? T("fit_rs_line") : advice === "true_to_size" ? T("fit_tts_line") : "";
      if (advice === "runs_small" && state.size && state.size === firstAvail) {
        txt = T("fit_rs_small_sel");
      }
      lineEl.innerHTML = txt;
    }

    function paint() {
      const av = P.availability[P.colors[state.color].key];
      el.innerHTML = "";
      P.sizes.forEach((s) => {
        const b = document.createElement("button");
        b.className = "size-pill";
        b.textContent = s;
        b.type = "button";
        const ok = av[s];
        if (!ok) b.classList.add("is-soldout");
        if (state.size === s) b.classList.add("is-active");
        // a11y: vybraný stav i vyprodanost sděl programově (sám vizuál SR nestačí).
        // Vyprodané zůstávají klikatelné (spustí hlídacího psa) → ne aria-disabled, jen popis.
        b.setAttribute("aria-pressed", state.size === s ? "true" : "false");
        b.setAttribute("aria-label", ok ? s : s + " – " + T("soldout_btn"));
        // vyprodané jsou KLIKATELNÉ — výběr spustí hlídacího psa (Stoq)
        b.addEventListener("click", () => {
          const before = state.size;
          state.size = s;
          // posun rozložení velikostí měříme v OBOU větvích (treatment i holdout) přes ab=bucket
          if (before !== s) track("size_select", { size: s, index: P.sizes.indexOf(s), ab: bucket });
          emit();
        });
        el.appendChild(b);
      });
      if (hint) {
        // rozměr velikosti ukazujeme u VŠECH produktů; fit-průvodce navíc jen u fit-rizikových (treatment).
        buildHint();
        hint.style.display = "";
        paintMeasure();
        if (showFit) {
          paintFitLine();
          if (!fitViewed) {
            fitViewed = true;
            track("fit_hint_view", { advice });
          }
        }
      }
    }
    paint();
    onChange(paint);
  }

  /* ---------- MNOŽSTVÍ ---------- */
  function renderQty(el) {
    el.innerHTML =
      '<button type="button" data-dec aria-label="' + T("qty_less") + '">−</button><input type="text" inputmode="numeric" data-val value="1" aria-label="' + T("qty_label") + '"><button type="button" data-inc aria-label="' + T("qty_more") + '">+</button>';
    const val = $("[data-val]", el);
    $("[data-dec]", el).addEventListener("click", () => {
      state.qty = Math.max(1, state.qty - 1);
      emit();
    });
    $("[data-inc]", el).addEventListener("click", () => {
      const max = Math.min(20, currentStock());
      if (state.qty >= max) {
        qtyNag(); // nejde víc než sklad → tooltip + zatřesení
        return;
      }
      state.qty = state.qty + 1;
      emit();
    });
    // psaní přímo do pole: během psaní povol jen číslice (max 2), platnou hodnotu uplatni na blur/Enter
    val.addEventListener("input", () => {
      val.value = val.value.replace(/\D+/g, "").slice(0, 2);
    });
    function commitTyped() {
      const max = Math.min(20, currentStock());
      let n = parseInt(val.value, 10);
      if (!n || n < 1) n = 1;
      if (n > max) {
        n = max;
        qtyNag(); // psané číslo nad sklad/limit → ořízni a upozorni
      }
      if (n !== state.qty) state.qty = n;
      emit(); // i při shodě: znormalizuj zobrazení (prázdné/„07" → správná hodnota)
    }
    val.addEventListener("blur", commitTyped);
    val.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        val.blur();
      }
    });
    onChange(() => {
      if (val.value !== String(state.qty)) val.value = state.qty;
    });
  }

  /* ---------- SLEVOVÝ ŽEBŘÍK ---------- */
  function renderLadder(el) {
    const rows = document.createElement("div");
    rows.className = "ladder__rows";
    const head = document.createElement("div");
    head.className = "ladder__head";
    head.innerHTML = "Víc kousků, nižší cena za kus";
    const hint = document.createElement("div");
    hint.className = "ladder__hint";
    const steps = [{ min: 1, pct: 0 }, ...P.discounts];
    steps.forEach((d) => {
      const s = document.createElement("button");
      s.className = "ladder__step";
      s.innerHTML = `<b>${d.min}${d.min === 5 ? "+" : ""} ks</b><small>${
        d.pct ? "−" + d.pct + " %" : "základ"
      }</small>`;
      s.addEventListener("click", () => {
        state.qty = d.min;
        emit();
      });
      rows.appendChild(s);
    });
    el.append(head, rows, hint);

    function paint() {
      const cur = discountFor(state.qty);
      $$(".ladder__step", rows).forEach((s, i) => {
        const d = steps[i];
        s.classList.toggle("is-active", d.min === cur.min);
        s.classList.toggle("is-reached", state.qty >= d.min);
      });
      // další práh
      const nxt = P.discounts.find((d) => d.min > state.qty);
      if (nxt) {
        hint.innerHTML = `Přidej ještě ${nxt.min - state.qty} ks a ušetři <b>${nxt.pct} %</b> z každého kusu (−${fmt((P.price * nxt.pct) / 100)}/ks).`;
      } else {
        hint.innerHTML = `Tohle je nejlepší cena, jakou pro tebe máme — <b>−${cur.pct} %</b> na každý kousek. 🤍`;
      }
    }
    paint();
    onChange(paint);
  }

  /* ---------- CENA (binding) ---------- */
  // POZN. (latentní): per-variant cena NENÍ podporována — P.price/P.compareAt se z Liquidu
  // nastaví jednou (vybraná/první dostupná varianta) a klientské přepnutí barvy/velikosti je
  // nepřepisuje (chybí cenová mapa [colorKey][size]). Konzistentní jen u jednotně naceněných
  // variant; různě naceněné varianty by vyžadovaly per-variant cenovou mapu z Liquidu.
  function bindPrices() {
    // produkt bez slevy (compare_at ≤ cena): skryj škrtlou cenu, „−X %" i „Nejnižší cena roku",
    // ať se nezobrazuje klamavá stejná cena dvakrát. Guard na === false (starý Liquid bez flagu → beze změny).
    if (P.hasSale === false) root().classList.add("no-sale");
    // přepiš text jen když se reálně mění → změna velikosti (stejná cena) nespustí mikroanimaci ceny
    const setText = (e, v) => {
      if (e.textContent !== v) e.textContent = v;
    };
    function paint() {
      // horní cena = aktuální cena za kus (mění se s množstevní slevou / předplatným)
      const unit = unitPrice(state.qty);
      // původní (škrtnutá) cena je vždy stejná (449 Kč) v obou režimech; mění se jen sleva v %
      $$("[data-price-now]").forEach((e) => setText(e, fmt(unit)));
      $$("[data-price-old]").forEach((e) => setText(e, fmt(P.compareAt)));
      $$("[data-price-save]").forEach((e) =>
        setText(e, "−" + Math.round((1 - unit / P.compareAt) * 100) + " %")
      );
      $$("[data-unit]").forEach((e) =>
        setText(e, state.qty > 1 ? fmt(unit) + " / ks" : "")
      );
      $$("[data-total]").forEach((e) => setText(e, fmt(totalPrice(state.qty))));
    }
    paint();
    onChange(paint);
  }

  // aktuální variant ID z mapy (Liquid ji vyplní z reálných variant)
  function currentVariantId() {
    const ids = P.variantIds && P.variantIds[P.colors[state.color].key];
    return ids ? ids[state.size] : null;
  }

  /* ---------- ADD TO CART (nativní theme product-form + Stoq) ---------- */
  // Submit obstará theme <product-form> (AJAX + drawer + chyby). My jen:
  //  - synchronizujeme skryté name="id" (varianta) a name="quantity" (množství),
  //  - ohlídáme zvolenou velikost,
  //  - u nedostupné varianty submit/id disablne bindStock → Stoq se ukáže sám.
  function syncForm() {
    const id = currentVariantId();
    $$("[data-variant-id]").forEach((inp) => {
      if (id) inp.value = id;
      // change/input → ať změnu varianty zaregistruje theme i Restock Rocket
      inp.dispatchEvent(new Event("input", { bubbles: true }));
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });
    $$("[data-qty-input]").forEach((inp) => (inp.value = state.qty));
    // promítni vybranou variantu do URL (?variant=ID) — jako nativní šablona (bez nové položky historie)
    if (id && window.history && history.replaceState) {
      try {
        const u = new URL(window.location.href);
        u.searchParams.set("variant", id);
        history.replaceState({}, "", u.toString());
      } catch (e) {}
    }
    // signál pro back-in-stock appky napojené na výběr varianty
    document.dispatchEvent(new CustomEvent("variant:change", { detail: { id: id } }));
    // theme pub/sub (Be Yours) — Restock Rocket i ostatní appky poslouchají „variant-change"
    if (id && typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      try {
        const c = P.colors[state.color];
        const pf = $("[data-section-id]");
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: pf ? pf.dataset.sectionId : undefined,
            variant: {
              id: id,
              available: !isSoldOut(),
              option1: c.sub ? c.name + " | " + c.sub : c.name,
              option2: state.size,
              options: [c.name, state.size],
            },
          },
        });
      } catch (e) {}
    }
  }
  function bindATC() {
    syncForm();
    onChange(syncForm);
    $$("[data-buybox] form, form.nebe-form").forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault(); // vždy AJAX → žádný redirect na /cart
        // hlídání velikosti
        if (!state.size) {
          showSizeErr();
          const block = $(".sizes-block") || $("[data-sizes]");
          if (block && block.scrollIntoView)
            block.scrollIntoView({ behavior: "smooth", block: "center" });
          bumpSizes();
          return;
        }
        if (isSoldOut()) return; // vyprodáno → Restock Rocket řeší appka
        addToCart(form);
      });
    });
    // jakmile velikost vybere, chybovou hlášku schovej
    onChange(() => {
      if (!state.size) return;
      const err = $("[data-size-err]");
      if (err && !err.hidden) {
        err.hidden = true;
        err.textContent = "";
      }
    });
  }
  // výrazná hláška „vyber velikost" (s naskočením)
  function showSizeErr() {
    const err = $("[data-size-err]");
    if (!err) return;
    // a11y: validační hláška „vyber velikost" se musí oznámit SR (Liquid kontejner je prostý div)
    if (err.getAttribute("role") !== "alert") {
      err.setAttribute("role", "alert");
      err.setAttribute("aria-live", "assertive");
    }
    err.hidden = false;
    err.textContent = T("size_err");
    if (!reduced() && err.animate)
      err.animate(
        [
          { transform: "scale(.85)", opacity: 0 },
          { transform: "scale(1.05)", opacity: 1 },
          { transform: "scale(1)" },
        ],
        { duration: 320, easing: "ease-out" }
      );
  }
  // upozorni na nevybranou velikost: zatřesení blokem + červené orámování dlaždic
  function bumpSizes() {
    const sizes = $("[data-sizes]");
    if (!sizes) return;
    sizes.classList.add("nag");
    setTimeout(() => sizes.classList.remove("nag"), 1500);
    if (!reduced() && sizes.animate) {
      sizes.animate(
        [
          { transform: "translateX(0)" },
          { transform: "translateX(-10px)" },
          { transform: "translateX(10px)" },
          { transform: "translateX(-8px)" },
          { transform: "translateX(8px)" },
          { transform: "translateX(-4px)" },
          { transform: "translateX(0)" },
        ],
        { duration: 620, easing: "ease-in-out" }
      );
    }
    flash(sizes);
  }

  // AJAX přidání do košíku + otevření drawer <mini-cart> (replikuje theme product-form.js)
  function addToCart(form) {
    const submit = $("[data-atc]", form) || $("[data-atc]");
    if (submit && submit.getAttribute("aria-disabled") === "true") return;
    if (submit) {
      submit.setAttribute("aria-disabled", "true");
      submit.classList.add("loading");
    }

    const cart =
      document.querySelector("mini-cart") ||
      document.querySelector("cart-drawer") ||
      document.querySelector("cart-notification");

    const formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === "function") {
      formData.append("sections", cart.getSectionsToRender().map((s) => s.id));
      formData.append("sections_url", window.location.pathname);
      if (typeof cart.setActiveElement === "function")
        cart.setActiveElement(document.activeElement);
    }

    let addUrl = "/cart/add.js";
    try {
      if (typeof theme !== "undefined" && theme.routes && theme.routes.cart_add_url)
        addUrl = theme.routes.cart_add_url;
    } catch (e) {}

    fetch(addUrl, {
      method: "POST",
      headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          // chyba (např. nedostatek skladu) — bez úspěšného „✓" prefixu, ať nevypadá jako přidáno
          toast(response.description || response.message || T("add_error"), true);
          return;
        }
        // pub/sub o aktualizaci košíku (počítadlo v hlavičce, drawer obsah)
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "nebe-pdp",
              productVariantId: formData.get("id"),
              cart: response,
            });
          } catch (e) {}
        }
        if (cart && typeof cart.renderContents === "function") {
          if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
          cart.renderContents(response); // otevře drawer Be Yours
        } else {
          window.location = "/cart"; // fallback, když drawer na stránce není
        }
      })
      .catch(() => {
        window.location = "/cart";
      })
      .finally(() => {
        if (submit) {
          submit.classList.remove("loading");
          submit.removeAttribute("aria-disabled");
        }
      });
  }
  function flash(el) {
    if (!el) return;
    el.animate(
      [
        { boxShadow: "0 0 0 0 rgba(215,44,13,.0)" },
        { boxShadow: "0 0 0 6px rgba(215,44,13,.18)" },
        { boxShadow: "0 0 0 0 rgba(215,44,13,0)" },
      ],
      { duration: 700 }
    );
  }
  let toastT;
  function toast(msg, plain) {
    let t = $(".toast");
    if (!t) {
      t = document.createElement("div");
      t.className = "toast";
      // a11y: toast nese mj. chybu ATC i 'qtyNag' → musí se oznámit screen-readerům.
      // chyba (plain) = asertivní role=alert; běžné hlášky = polite, ať nepřebíjí čtení.
      t.setAttribute("role", plain ? "alert" : "status");
      t.setAttribute("aria-live", plain ? "assertive" : "polite");
      document.body.appendChild(t);
    } else {
      // znovupoužitý uzel: srovnej naléhavost dle typu hlášky
      t.setAttribute("role", plain ? "alert" : "status");
      t.setAttribute("aria-live", plain ? "assertive" : "polite");
    }
    t.textContent = (plain ? "" : "✓ ") + msg;
    requestAnimationFrame(() => t.classList.add("is-show"));
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove("is-show"), 2600);
  }

  /* ---------- STICKY ATC ---------- */
  function bindSticky() {
    const bar = $("[data-sticky-atc]");
    if (!bar) return;
    const title = $("[data-sticky-title]", bar);
    const sub = $("[data-sticky-sub]", bar);
    function paint() {
      if (title) title.textContent = P.title;
      if (sub)
        sub.textContent =
          P.colors[state.color].name +
          (state.size ? " · " + state.size : "") +
          " · " +
          fmt(totalPrice(state.qty));
    }
    paint();
    onChange(paint);

    // cockpit (.force-sticky): lišta je vždy viditelná
    if (root().classList.contains("force-sticky")) {
      bar.classList.add("is-visible");
      bar.setAttribute("aria-hidden", "false");
      return;
    }
    bar.setAttribute("aria-hidden", "true");
    // kotvíme na primární ATC tlačítko, aby se lišta objevila, jakmile zmizí z dohledu
    const anchor = $("[data-atc]") || $("[data-buybox]");
    if (!anchor || !("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver(
      ([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle("is-visible", show);
        bar.setAttribute("aria-hidden", show ? "false" : "true");
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  /* ---------- MOBILNÍ STICKY LIŠTIČKA (název + cena + hodnocení) ---------- */
  function bindMobileTopbar() {
    const bar = $("[data-mtopbar]");
    if (!bar) return;
    // sticky hlavička tématu (Be Yours: sticky-header / .header-wrapper / .section-header)
    const header =
      document.querySelector("sticky-header, .header-wrapper, .section-header, .shopify-section-group-header-group header") ||
      $(".hdr") ||
      $("[data-header]");
    const photo = $(".mosaic__main") || $(".heroGallery");
    const endRef = $(".aisum-wrap") || $("[data-sections]") || $("[data-nebe-end]");
    function update() {
      if (!root().classList.contains("mobile")) {
        bar.classList.remove("is-show");
        bar.style.top = "";
        return;
      }
      // lištička navazuje TĚSNĚ POD sticky hlavičku webu
      const hH = header ? header.getBoundingClientRect().height : 56;
      bar.style.top = hH + "px";
      const pb = photo ? photo.getBoundingClientRect().bottom : 0;
      const et = endRef ? endRef.getBoundingClientRect().top : Infinity;
      // objev se, jakmile název/cena ve fotce zajede pod hlavičku; skryj u shrnutí recenzí
      const show = pb < hH + 40 && et > hH + 8;
      bar.classList.toggle("is-show", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }
    let ticking = false;
    addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );
    addEventListener("resize", update, { passive: true });
    update();
  }

  /* ---------- HLÍDACÍ PES / STOQ (vyprodaná varianta) ---------- */
  function isSoldOut() {
    return (
      state.size && !P.availability[P.colors[state.color].key][state.size]
    );
  }
  // celá barva vyprodaná = žádná velikost dostupná
  function colorAllSoldOut() {
    const av = P.availability[P.colors[state.color].key] || {};
    return !Object.values(av).some(Boolean);
  }
  // skladová zásoba zvolené velikosti (Infinity = neznámé/nehlídané → neomezovat)
  function currentStock() {
    if (!state.size) return Infinity;
    const s = (P.stock && P.stock[P.colors[state.color].key]) || {};
    const n = s[state.size];
    return typeof n === "number" && n >= 0 ? n : Infinity;
  }
  const ksWord = unitWord; // alias na i18n skloňování
  // upozornění při pokusu překročit sklad: tooltip + zatřesení stepperu
  function qtyNag() {
    const n = currentStock();
    if (n === Infinity) return;
    toast(T("qty_nag", { n, unit: unitWord(n) }), true);
    const q = $("[data-qty]");
    if (q && q.animate && !reduced())
      q.animate(
        [
          { transform: "translateX(0)" },
          { transform: "translateX(-6px)" },
          { transform: "translateX(6px)" },
          { transform: "translateX(0)" },
        ],
        { duration: 360, easing: "ease-in-out" }
      );
    flash(q);
  }
  // Žádný vlastní formulář — u vyprodané velikosti jen označíme stav a DISABLEneme
  // nativní submit + variant-id input. Reálný Stoq (app embed) se na to napojí sám.
  function bindStock() {
    function paint() {
      // sold-out stav (skryje výběr počtu/Přidat) = vybraná velikost nedostupná NEBO celá barva vyprodaná
      const so = isSoldOut() || colorAllSoldOut();
      root().classList.toggle("is-soldout", !!so);
      // signál pro Stoq i pro Shopify: vybraná varianta není dostupná
      $$("[data-variant-id]").forEach((inp) => {
        if (so) inp.setAttribute("disabled", "disabled");
        else inp.removeAttribute("disabled");
      });
      $$("[data-buybox] [data-atc]").forEach((b) => {
        b.disabled = !!so;
        const lab = $(".label", b);
        if (lab) {
          if (!lab.dataset.orig) lab.dataset.orig = lab.textContent;
          // konflikt s bindSubFx nad stejným .label: v režimu předplatného NEpřepisuj
          // label zpět na cachovaný „Přidat do košíku" — nech řídit label předplatnému.
          // (bindStock běží PO bindSubFx, takže by jinak jeho text přebil.)
          if (so) lab.textContent = T("soldout_btn");
          else if (!subActive()) lab.textContent = lab.dataset.orig;
        }
      });
    }
    paint();
    onChange(paint);
  }

  /* ---------- AKORDEONY ---------- */
  function bindAccordions() {
    $$("[data-accordion]").forEach((acc, i) => {
      const head = $(".accordion__head", acc);
      const body = $(".accordion__body", acc);
      const id = "acc-body-" + i;
      body.id = id;
      head.setAttribute("aria-controls", id);
      head.setAttribute("aria-expanded", "false");
      const pm = $(".pm", head);
      if (pm) pm.setAttribute("aria-hidden", "true");
      head.addEventListener("click", () => {
        const open = acc.classList.toggle("is-open");
        head.setAttribute("aria-expanded", open ? "true" : "false");
        body.style.maxHeight = open ? body.scrollHeight + "px" : 0;
      });
    });
  }

  /* ---------- SIZE GUIDE MODAL ---------- */
  function bindSizeGuide() {
    const modal = $("[data-size-modal]");
    if (!modal) return;
    const card = $(".modal__card", modal);
    const closeBtn = $(".modal__close", modal);
    const h = $("h3", card);
    if (h && !h.id) h.id = "size-modal-title";
    card.setAttribute("role", "dialog");
    card.setAttribute("aria-modal", "true");
    if (h) card.setAttribute("aria-labelledby", h.id);
    if (closeBtn) closeBtn.setAttribute("aria-label", T("lightbox_close"));
    let lastFocus = null;
    // a11y: zneaktivni zbytek stránky, ať SR/Tab nepřejde na obsah pod modálem.
    // Sourozenci <main>/sekcí kromě samotného modalu dostanou aria-hidden + inert.
    const bgEls = () => {
      // skryj všechny přímé děti <body> kromě toho, který obsahuje (nebo je) modal
      const sibs = [];
      Array.from(document.body.children).forEach((c) => {
        if (c !== modal && !c.contains(modal)) sibs.push(c);
      });
      return sibs;
    };
    const setInert = (on) => {
      bgEls().forEach((c) => {
        if (on) {
          c.setAttribute("aria-hidden", "true");
          c.setAttribute("inert", "");
        } else {
          c.removeAttribute("aria-hidden");
          c.removeAttribute("inert");
        }
      });
    };
    const open = () => {
      lastFocus = document.activeElement;
      modal.classList.add("is-open");
      document.body.style.overflow = "hidden";
      setInert(true);
      $$(".sizetable tr", modal).forEach((tr) =>
        tr.classList.toggle("is-active", tr.dataset.size === state.size)
      );
      if (closeBtn && closeBtn.focus) closeBtn.focus();
    };
    const close = () => {
      modal.classList.remove("is-open");
      document.body.style.overflow = "";
      setInert(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    $$("[data-size-open]").forEach((b) => b.addEventListener("click", open));
    $(".modal__bg", modal).addEventListener("click", close);
    if (closeBtn) closeBtn.addEventListener("click", close);
    document.addEventListener("keydown", (e) => {
      if (!modal.classList.contains("is-open")) return;
      if (e.key === "Escape") {
        close();
        return;
      }
      if (e.key === "Tab") {
        // a11y: Tab-trap – fokus drž uvnitř karty modalu
        const f = $$("a[href], button, input, select, textarea, [tabindex]", card).filter(
          (x) => !x.disabled && x.offsetParent !== null && x.getAttribute("tabindex") !== "-1"
        );
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (!card.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  /* ---------- SCROLL REVEAL ---------- */
  function bindReveal() {
    const els = $$("[data-reveal]");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach((e) => e.classList.add("is-in"));
      return;
    }
    const io = new IntersectionObserver(
      (ents) =>
        ents.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.16 }
    );
    els.forEach((e) => io.observe(e));
  }

  /* ---------- PARALLAX (varianta D) ---------- */
  function bindParallax() {
    const els = $$("[data-parallax]");
    if (!els.length || root().classList.contains("rm")) return;
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return;
    let ticking = false;
    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          els.forEach((el) => {
            const r = el.getBoundingClientRect();
            const off = (r.top + r.height / 2 - innerHeight / 2) * -0.06;
            el.style.transform = "translate3d(0," + off.toFixed(1) + "px,0)";
          });
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  /* ---------- SVG IKONY ---------- */
  const ICONS = {
    leaf: "<path d='M3 21c0-9 7-16 18-16 0 11-7 17-18 16'/><path d='M8.5 16.5C11 12 14.5 9.5 19 8'/>",
    heart:
      "<path d='M12 20S3.5 14.5 3.5 8.8C3.5 6 5.7 4 8.2 4c1.7 0 3 .9 3.8 2.1C12.8 4.9 14.1 4 15.8 4 18.3 4 20.5 6 20.5 8.8 20.5 14.5 12 20 12 20z'/>",
    globe:
      "<circle cx='12' cy='12' r='9'/><path d='M3 12h18M12 3c2.5 2.6 3.8 5.8 3.8 9S14.5 18.4 12 21C9.5 18.4 8.2 15.2 8.2 12S9.5 5.6 12 3z'/>",
    return:
      "<path d='M3 8h11a6 6 0 0 1 0 12H8'/><path d='M7 4 3 8l4 4'/>",
  };
  const icon = (n) =>
    `<svg class="bicon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">${ICONS[n] || ""}</svg>`;
  const starStr = (n) => "★".repeat(n) + "☆".repeat(5 - n);
  // plamínek k sociální proof „X prodaných" (SVG, ne emoji)
  const FLAME =
    '<svg class="flame" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.963 2.286a.75.75 0 0 0-1.071-.136 9.742 9.742 0 0 0-3.539 6.177 7.547 7.547 0 0 1-1.705-1.715.75.75 0 0 0-1.152-.082A9 9 0 1 0 15.68 4.534a7.46 7.46 0 0 1-2.717-2.248zM15.75 14.25a3.75 3.75 0 1 1-7.313-1.172c.628.465 1.35.81 2.133 1a5.99 5.99 0 0 1 1.925-3.547 3.75 3.75 0 0 1 3.255 3.719z"/></svg>';

  /* ---------- HLAVIČKA (replika z webu) ---------- */
  function renderHeader(el) {
    const h = P.header;
    const SV = {
      burger:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg>',
      search:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.6-3.6"/></svg>',
      acc:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3.6"/><path d="M5 20c.6-3.7 3.4-5.6 7-5.6s6.4 1.9 7 5.6"/></svg>',
      cart:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 8h11l-1 11.4a1 1 0 0 1-1 .9H8.5a1 1 0 0 1-1-.9L6.5 8z"/><path d="M9 8V6.9a3 3 0 0 1 6 0V8"/></svg>',
    };
    el.innerHTML = `
      <div class="hdr">
        <div class="hdr__left">
          <button class="hdr__icon hdr__burger" aria-label="Menu">${SV.burger}</button>
          <nav class="hdr__nav">${h.menu.map((m) => `<a href="#">${m}</a>`).join("")}</nav>
        </div>
        <a class="hdr__logo" href="#">nebe</a>
        <div class="hdr__right">
          <button class="hdr__icon" aria-label="Hledat">${SV.search}</button>
          <button class="hdr__icon" aria-label="Účet">${SV.acc}</button>
          <button class="hdr__icon hdr__cart" aria-label="Košík">${SV.cart}<i data-cart-count>0</i></button>
        </div>
      </div>`;
    onCart((n) => {
      const c = $("[data-cart-count]", el);
      if (c) c.textContent = n;
    });
  }

  /* ---------- SDÍLENÉ SEKCE (benefity / média / recenze / akordeon) ---------- */
  function sectionBenefits() {
    return `<section class="section why"><div class="wrap">
      <h2 class="section__title" data-reveal>Proč si tvé tělo zamiluje <span class="ink">nebe</span>?</h2>
      <div class="why__grid">${P.benefits
        .map(
          (b) =>
            `<div class="why__item" data-reveal>${icon(b.icon)}<h3>${b.title}</h3><p>${b.text}</p></div>`
        )
        .join("")}</div></div></section>`;
  }
  function sectionPress() {
    return `<section class="section press"><div class="wrap">
      <h3 class="press__title" data-reveal>Odkud také už <span class="ink">nebe</span> znáš</h3>
      <div class="press__row" data-reveal>${P.press
        .map((p) => `<img class="press__logo" src="${p.src}" alt="${p.alt}" loading="lazy">`)
        .join("")}</div></div></section>`;
  }
  function sectionReviews() {
    const r = Math.round(P.rating);
    return `<section class="section section--soft reviews" id="recenze"><div class="wrap">
      <h2 class="section__title" data-reveal>Co říkají <span class="ink">zákazníci</span> o tomto kousku?</h2>
      <div class="quotes">${P.quotes
        .map(
          (q) =>
            `<blockquote class="quote quote--${q.align}" data-reveal><p>${q.text}</p><cite>— ${q.author}</cite></blockquote>`
        )
        .join("")}</div>
      <div class="rev-summary" data-reveal>
        <div class="rev-summary__score"><b>${P.rating.toFixed(1).replace(".",",")}</b>
          <span><span class="stars">${starStr(r)}</span><small>${P.reviewCount} recenzí</small></span></div>
        <div class="rev-summary__actions">
          <button class="btn-outline">Napiš recenzi</button>
          <button class="btn-outline">Polož nám otázku</button></div>
      </div>
      <div class="rev-tabs"><button class="on">Recenze (${P.reviewCount})</button><button>Otázky k produktu (0)</button></div>
      <div class="rev-list">${P.reviews
        .map(
          (rv) =>
            `<div class="rev-card"><div class="rev-card__head">
              <b>${rv.name} ${rv.flag}</b>${rv.verified ? '<span class="verif">✓ Ověřený nákup</span>' : ""}
              <span class="stars">${starStr(rv.stars)}</span></div><p>${rv.text}</p></div>`
        )
        .join("")}</div></div></section>`;
  }
  function sectionAccordions() {
    const items = [
      ["Materiál &amp; složení", "95 % bambusová viskóza (Oeko-Tex® Standard 100), 5 % elastan. Hypoalergenní, prodyšný, jemný na dotek."],
      ["Péče &amp; praní", "<ul><li>Prát na 30 °C</li><li>Nebělit</li><li>Sušit volně, nesušit v sušičce</li><li>Nežehlit přímo na gumu</li></ul>"],
      ["Velikosti &amp; rozměry", 'Standardní EU velikosti XS–XL podle obvodu boků (86–120 cm). <a data-size-open style="text-decoration:underline;cursor:pointer">Otevřít tabulku velikostí →</a>'],
      ["Doprava &amp; vrácení", "Doprava zdarma od 2 500 Kč. 30 dní na vrácení zdarma."],
    ];
    return `<section class="section"><div class="wrap" style="max-width:640px">
      <h2 class="section__title" style="margin-bottom:24px" data-reveal>Vše o brazilkách <span class="ink">Aura</span></h2>
      ${items
        .map(
          ([t, b]) =>
            `<div class="accordion" data-accordion><button class="accordion__head">${t} <span class="pm">+</span></button><div class="accordion__body"><div class="accordion__inner">${b}</div></div></div>`
        )
        .join("")}</div></section>`;
  }
  // PŘEDĚL: celá barevná řada (à la CANS lineup). Pozadí lze vyměnit za foto
  // obrandované krabice přes CSS proměnnou --break-bg na elementu .lineup.
  function sectionLineup() {
    return `<section class="section lineup"><div class="wrap">
      <h2 class="section__title" data-reveal>Najdi <span class="ink">svou barvu</span></h2>
      <p class="section__sub" data-reveal>Šest odstínů Aury. Kterou si vezmeš dnes?</p>
      <div class="lineup__row" data-reveal>${P.colors
        .map(
          (c, i) =>
            `<button class="lineup__item" data-pick-color="${i}">
              <span class="lineup__img"><img loading="lazy" src="${W(gimg(c.gallery[0]), 420)}" alt="${escapeHtml(c.name)}"></span>
              <b>${escapeHtml(c.name)}</b><small>${escapeHtml(c.sub)}</small></button>`
        )
        .join("")}</div></div></section>`;
  }

  function bindColorPicks() {
    document.addEventListener("click", (e) => {
      const t = e.target.closest("[data-pick-color]");
      if (!t) return;
      state.color = parseInt(t.dataset.pickColor, 10);
      emit();
      const bb = $("[data-buybox]");
      if (bb && bb.scrollIntoView)
        bb.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  // Vykukující cutout brazilek (jen mobil) — mění se s barvou + crossfade
  function renderPeek(el) {
    const paint = () => {
      el.innerHTML = `<img src="${P.colors[state.color].photo}" alt="">`;
    };
    let last = state.color;
    paint();
    onChange(() => {
      if (state.color === last) return;
      last = state.color;
      el.style.transition = "opacity .3s var(--ease)";
      el.style.opacity = "0";
      setTimeout(() => {
        paint();
        el.style.opacity = "1";
      }, 260);
    });
  }

  // Reálný počet skladem (pravdivá scarcity z Shopify dat)
  function renderStock(el) {
    // a11y: změny skladu/dostupnosti oznamuj SR jemně (polite), ať neruší při psaní/čtení
    if (!el.getAttribute("aria-live")) {
      el.setAttribute("aria-live", "polite");
      el.setAttribute("role", "status");
    }
    function paint() {
      const s = (P.stock && P.stock[P.colors[state.color].key]) || {};
      el.classList.remove("is-low", "is-lowstock");
      el.style.display = "";
      if (state.size) {
        const n = s[state.size] || 0;
        if (n <= 0) {
          el.innerHTML = `<span class="dot"></span> ${T("stock_size_out")}`;
          el.classList.add("is-low");
        } else if (n <= 3) {
          el.innerHTML = T("stock_last_n", { n });
          el.classList.add("is-lowstock");
        } else if (n <= 10) {
          el.innerHTML = `<span class="dot"></span> ${T("stock_few", { ship: shipNote() })}`;
          el.classList.add("is-lowstock");
        } else {
          el.innerHTML = `<span class="dot"></span> ${T("stock_in", { ship: shipNote() })}`;
        }
      } else {
        const av = P.availability[P.colors[state.color].key] || {};
        if (!Object.values(av).some(Boolean)) {
          el.innerHTML = `<span class="dot"></span> ${T("stock_color_out")}`;
          el.classList.add("is-low");
        } else {
          // bez vybrané velikosti neukazuj „Skladem" (ale nech rezervované místo, ať nic neposkočí)
          el.innerHTML = "";
        }
      }
    }
    paint();
    onChange(paint);
  }

  // Bundle nabídka „kup víc a ušetři": ukaž VŠECHNY prahy (1 ks + každý slevový práh).
  // Desktop = řada karet; mobil = jeden box s vybraným řádkem (CSS). Aktivní = největší práh ≤ počet.
  function renderBundles(el) {
    const lbl = (q) => q + " " + unitWord(q);
    function build() {
      const stock = currentStock();
      const qtys = [1].concat(P.discounts.map((d) => d.min));
      const uniq = qtys
        .filter((q, i) => qtys.indexOf(q) === i)
        .sort((a, b) => a - b)
        .filter((q) => q <= stock);
      const last = uniq.length - 1;
      const activeQ = uniq.filter((u) => u <= state.qty).pop() || uniq[0];
      const tiles = uniq
        .map((q, i) => {
          const unit = unitPrice(q);
          const save = P.price * q - totalPrice(q);
          const active = q === activeQ;
          let badge = "";
          if (i === last && uniq.length > 1) badge = T("bundle_best");
          else if (i === last - 1 && uniq.length > 2) badge = T("bundle_popular");
          const qlbl = i === last && uniq.length > 1 ? q + " " + T("bundle_more") : lbl(q);
          return `<button class="bundle${active ? " is-active" : ""}" data-bq="${q}">
            ${badge ? `<span class="bundle__badge">${badge}</span>` : ""}
            <span class="bundle__radio" aria-hidden="true"></span>
            <b class="bundle__qty">${qlbl}</b>
            <span class="bundle__main">
              <span class="bundle__price"><span class="bundle__amt">${fmt(unit)}</span><span class="bundle__per">${q > 1 ? T("per_piece") : ""}</span></span>
              ${save > 0 ? `<small class="bundle__save">${T("bundle_save", { amount: fmt(save) })}</small>` : ""}
            </span>
          </button>`;
        })
        .join("");
      el.innerHTML =
        `<div class="bundles__group">${tiles}</div>` +
        `<p class="bundle__combo">${T("bundle_combo_html")}</p>`;
    }
    build();
    el.addEventListener("click", (e) => {
      const b = e.target.closest("[data-bq]");
      if (!b) return;
      state.qty = parseInt(b.dataset.bq, 10);
      emit();
    });
    onChange(build);
  }

  // PŘEDPLATNÉ: přepínač jednorázový nákup vs. předplatné + frekvence (à la Subscribe & Save)
  const capFirst = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  function toggleSubMode() {
    state.mode = state.mode === "sub" ? "onetime" : "sub";
    // jednorázový nákup nemá exkluzivní barvu → přepni na první běžnou
    if (state.mode === "onetime" && P.colors[state.color].subOnly) {
      state.color = 0;
      if (state.size && !P.availability[P.colors[0].key][state.size]) state.size = null;
    }
    emit();
  }
  // minimalistické přepínátko předplatného (sedí vpravo u „Kolik kusů?")
  function renderPurchase(el) {
    if (!SUBP) return;
    function build() {
      const on = state.mode === "sub";
      el.innerHTML = `<button class="subtoggle${on ? " is-on" : ""}" role="switch" aria-checked="${on}" data-sub-toggle>
        <span class="subtoggle__sw" aria-hidden="true"></span>
        <span class="subtoggle__lbl">Posílat pravidelně, <b>ušetři ${SUBP.pct} %</b></span>
      </button>`;
    }
    build();
    el.addEventListener("click", (e) => {
      if (e.target.closest("[data-sub-toggle]")) toggleSubMode();
    });
    onChange(build);
  }
  // obsah, který se v sekci „Kolik kusů?" objeví po zapnutí předplatného (frekvence + bonusy)
  function renderSubPanel(el) {
    if (!SUBP) return;
    const exclColor = P.colors.find((c) => c.subOnly);
    function build() {
      const fLabel = (SUBP.frequencies.find((x) => x.weeks === state.freq) || SUBP.frequencies[0]).label;
      el.innerHTML = `
        <div class="subfreq__opts" role="radiogroup" aria-label="Jak často doručit">${SUBP.frequencies
          .map(
            (f) =>
              `<button class="freqpill${state.freq === f.weeks ? " is-active" : ""}" role="radio" aria-checked="${state.freq === f.weeks}" data-freq="${f.weeks}">${f.label}</button>`
          )
          .join("")}</div>
        <p class="subhow"><b>Jak to funguje:</b> Dnes zaplatíš <b>${fmt(totalPrice(state.qty))}</b> za <b>${state.qty} ks</b> a pošleme ti je hned. Pak ti <b>${fLabel}</b> pošleme <b>${state.qty} ks</b> znovu a teprve potom zaplatíš dalších <b>${fmt(totalPrice(state.qty))}</b> — a vždy ti dáme pár dní dopředu vědět e‑mailem. Zrušíš, kdykoliv budeš chtít.</p>
        <ul class="subperks">
          <li><b>Jako první ti přijde barva, kterou sis vybrala.</b> Další balíčky tě překvapíme jinou — i barvami, které u nás normálně nekoupíš. Chceš konkrétní? Stačí nám dopředu napsat.</li>
          <li><b>Zrušíš na jedno kliknutí</b> — ve svém účtu nebo přes odkaz v e‑mailu. Zdarma, bez volání a bez výpovědní lhůty.</li>
          <li>Doprava vždycky zdarma</li>
        </ul>`;
    }
    build();
    el.addEventListener("click", (e) => {
      const fq = e.target.closest("[data-freq]");
      if (fq) {
        state.freq = parseInt(fq.dataset.freq, 10);
        emit();
      }
    });
    onChange(build);
  }
  // Návazné efekty režimu předplatného: třída na body, text CTA, popisek množství
  function bindSubFx() {
    if (!subEnabled) return;
    function update() {
      root().classList.toggle("mode-sub", subActive());
      $$("[data-buybox] [data-atc] .label").forEach(
        (l) => (l.textContent = subActive() ? "Začít posílat pravidelně" : "Přidat do košíku")
      );
      $$("[data-qty-cap]").forEach(
        (c) => (c.textContent = subActive() ? "Jak často poslat?" : "Kolik kusů?")
      );
    }
    update();
    onChange(update);
  }

  // Sentiment ukazatele z recenzí (D-4r) — proužky se značkou „kde to je"
  function ratingBarsHTML() {
    const R = P.ratings;
    if (!R) return "";
    return R.map(
      (r) => `
        <div class="rbar">
          <div class="rbar__label">${r.label}</div>
          <div class="rbar__track" role="img" aria-label="${r.label}: ${r.pct} ze 100">
            <span class="rbar__fill" style="width:${r.pct}%"></span>
            <span class="rbar__thumb" style="left:${r.pct}%"></span>
          </div>
          <div class="rbar__ends"><span>${r.low}</span><span>${r.high}</span></div>
        </div>`
    ).join("");
  }
  function renderRatingBars(el) {
    if (!P.ratings) return;
    el.innerHTML = `<div class="ratings__head">Co na tom zákaznice milují</div>` + ratingBarsHTML();
  }

  // Mini-recenze u CTA
  function renderMiniReview(el) {
    const q = P.quotes[0];
    el.innerHTML = `<span class="stars" aria-hidden="true">${starStr(Math.round(P.rating))}</span><p>„${q.text}“ <cite>— ${q.author}</cite></p>`;
  }

  // AI shrnutí recenzí (externí aplikace) — sdílený blok pod úvodem
  function renderAiSummary(el) {
    const a = P.aiSummary;
    if (!a) return;
    el.innerHTML = `<div class="aisum">
      <div class="aisum__head"><span class="aisum__spark">✦</span><span>${a.title}</span></div>
      <p class="aisum__text">${a.text}</p>
      <div class="aisum__by">Vygenerováno umělou inteligencí <span class="aisum__chev">⌄</span></div>
      <div class="aisum__tags">${a.tags
        .map((t) => `<span class="aisum__tag">✓ ${t.label} (${t.pct} %)</span>`)
        .join("")}</div>
    </div>`;
  }

  function renderSections(el) {
    const want = (el.dataset.sections || "benefits,lineup,press,reviews,accordion")
      .split(",")
      .map((s) => s.trim());
    const map = {
      benefits: sectionBenefits,
      lineup: sectionLineup,
      press: sectionPress,
      reviews: sectionReviews,
      accordion: sectionAccordions,
    };
    el.innerHTML = want.map((k) => (map[k] ? map[k]() : "")).join("");
  }

  /* ---------- INIT ---------- */
  function init() {
    ROOT = document.querySelector(".nebe-pdp") || document.body;
    if (params.get("rm") === "1") ROOT.classList.add("rm");
    applyDev();
    // PORTÁL: přesuň modal velikostí na <body> (mimo transformovaný rodič tématu,
    // který láme position:fixed → pozadí by se neztmavilo a popup by byl mimo střed)
    (function portalModal() {
      const modal = $("[data-size-modal]");
      if (!modal || modal.parentElement === document.body) return;
      const portal = document.createElement("div");
      portal.className = "nebe-pdp nebe-portal";
      document.body.appendChild(portal);
      portal.appendChild(modal);
      const syncDev = () => {
        portal.classList.remove("mobile", "tablet", "desktop");
        portal.classList.add(dev || deviceFromWidth());
      };
      syncDev();
      window.addEventListener("resize", syncDev, { passive: true });
    })();
    // předplatné aktivní jen na stránce s blokem [data-purchase] (musí se zjistit před swatchi)
    subEnabled = !!(SUBP && $("[data-purchase]"));
    // předvybrat variantu z URL ?variant=ID (po reloadu/sdílení odkazu)
    (function preselectFromUrl() {
      const vp = params.get("variant");
      if (!vp || !P.variantIds) return;
      for (let ci = 0; ci < P.colors.length; ci++) {
        const map = P.variantIds[P.colors[ci].key] || {};
        for (const sz in map) {
          if (String(map[sz]) === String(vp)) {
            state.color = ci;
            state.size = sz;
            return;
          }
        }
      }
    })();
    // sklad-cap: při změně velikosti/barvy sniž množství, ať nepřekročí dostupný sklad (běží první)
    onChange(() => {
      const max = Math.min(20, currentStock());
      if (state.qty > max) state.qty = Math.max(1, max);
    });
    $$("[data-header]").forEach(renderHeader);
    $$("[data-ai-summary]").forEach(renderAiSummary);
    $$("[data-peek]").forEach(renderPeek);
    $$("[data-stock]").forEach(renderStock);
    $$("[data-bundles]").forEach(renderBundles);
    $$("[data-purchase]").forEach(renderPurchase);
    $$("[data-subpanel]").forEach(renderSubPanel);
    $$("[data-minireview]").forEach(renderMiniReview);
    $$("[data-ratings]").forEach(renderRatingBars);
    $$("[data-sections]").forEach(renderSections);
    // statické texty
    $$("[data-title]").forEach((e) => (e.textContent = P.title));
    $$("[data-vendor]").forEach((e) => (e.textContent = P.vendor));
    fitTitle();
    window.addEventListener("resize", fitTitle, { passive: true });
    // social-proof v mobilní liště: text z prahů / skrýt, když není
    $$("[data-sold-short]").forEach((e) => (e.textContent = P.soldBadgeShort || ""));
    $$("[data-sold]").forEach((e) => {
      if (!P.soldBadgeShort) e.style.display = "none";
    });
    const rRound = Math.round(P.rating);
    $$("[data-rating]").forEach((e) => {
      e.setAttribute(
        "aria-label",
        T("topbar_rating_aria", { rating: P.rating.toFixed(1).replace(".", ","), count: P.reviewCount })
      );
      e.innerHTML = `<span class="stars" aria-hidden="true">${starStr(rRound)}</span> ${P.rating.toFixed(1).replace(".",",")} · <a href="#recenze">${T("reviews_count", { n: P.reviewCount })}</a>`;
    });

    $$("[data-swatches]").forEach(renderSwatches);
    bindHeroImg();
    $$("[data-color-name]").forEach((e) => {
      renderColorName(e);
      // název barvy závisí jen na barvě → překresli (a re-animuj) jen při změně barvy,
      // ne při změně množství/velikosti (jinak se název zbytečně animuje)
      let lcName = state.color;
      onChange(() => {
        if (state.color === lcName) return;
        lcName = state.color;
        renderColorName(e);
      });
    });

    let gallery = null;
    $$("[data-gallery]").forEach((e) => (gallery = buildGallery(e)));
    $$("[data-thumbs]").forEach((e) => gallery && renderThumbs(e, gallery));
    $$("[data-mosaic]").forEach(buildMosaic);

    $$("[data-sizes]").forEach(renderSizes);
    $$("[data-qty]").forEach(renderQty);
    $$("[data-ladder]").forEach(renderLadder);

    // škrtlá cena + sleva na jeden řádek (nižší výška napříč variantami)
    $$(".price").forEach((p) => {
      const old = $("[data-price-old]", p);
      const save = $("[data-price-save]", p);
      if (old && save && !p.querySelector(".price__sub")) {
        const sub = document.createElement("span");
        sub.className = "price__sub";
        old.parentNode.insertBefore(sub, old);
        sub.appendChild(old);
        sub.appendChild(save);
      }
    });

    bindPrices();
    bindATC();
    bindSubFx();
    bindMobileTopbar();
    bindSticky();
    bindStock();
    bindAccordions();
    bindSizeGuide();
    bindReveal();
    bindParallax();
    bindColorPicks();

    emit(); // první vykreslení stavu
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
